module.exports = __webpack_public_path__ + "static/media/5x5no2.a997d25f.jpg";